// extracted by mini-css-extract-plugin
module.exports = {"hero":"Hero_hero__5UdGa","hero_heading":"Hero_hero_heading__d3X4B","btn":"Hero_btn__0RS_V"};